import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { Container, PageHeader } from "../components/ui-kit";
import { LEGAL } from "../mock";

const SECTIONS = [
  {
    h: "1. Veri Sorumlusunun Kimliği",
    p: [
      `6698 sayılı Kişisel Verilerin Korunması Kanunu (\u201cKVKK\u201d) uyarınca kişisel verileriniz, veri sorumlusu sıfatıyla ${LEGAL.company} (\u201cKoşan Düğme\u201d) tarafından aşağıda açıklanan kapsamda işlenmektedir.`,
      `Adres: ${LEGAL.address} · E-posta: ${LEGAL.email} · Telefon: ${LEGAL.phone}`,
      `MERSIS No: ${LEGAL.mersis} · Ticaret Sicil No: ${LEGAL.ticaretSicil} · KEP: ${LEGAL.kep}`,
    ],
  },
  {
    h: "2. İşlenen Kişisel Veriler",
    list: [
      "Kimlik: Ad ve soyad.",
      "İletişim: E-posta adresi, telefon numarası, firma adı.",
      "Müşteri İşlem / Talep: İletişim, teklif ve numune formları aracılığıyla ilettiğiniz mesaj ve talep içerikleri.",
      "İşlem Güvenliği: IP adresi ve çerezler aracılığıyla toplanan sınırlı teknik veriler.",
    ],
  },
  {
    h: "3. Kişisel Verilerin İşlenme Amaçları",
    list: [
      "Teklif, numune ve bilgi taleplerinizin karşılanması ve yürütülmesi.",
      "Sizinle iletişim kurulması ve talebinize dönüş yapılması.",
      "Ürün ve sipariş süreçlerinin planlanması ve yönetilmesi.",
      "Açık rızanıza dayalı olarak, tarafınıza ticari elektronik ileti (bülten) gönderilmesi.",
      "Bilgi güvenliğinin sağlanması ve yasal yükümlülüklerin yerine getirilmesi.",
    ],
  },
  {
    h: "4. İşlemenin Hukuki Sebepleri (KVKK m.5)",
    list: [
      "Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması (teklif ve talep süreçleri).",
      "Veri sorumlusunun meşru menfaati (iletişim ve müşteri ilişkilerinin yürütülmesi).",
      "İlgili kişinin açık rızası (ticari elektronik ileti gönderimi ve zorunlu olmayan çerezler).",
      "Hukuki yükümlülüklerin yerine getirilmesi.",
    ],
  },
  {
    h: "5. Toplama Yöntemi",
    p: [
      "Kişisel verileriniz; web sitemizdeki iletişim formu, teklif sepeti ve bülten aboneliği ile elektronik ortamda ve otomatik/kısmen otomatik yöntemlerle, yalnızca sizin tarafınızdan iletildiği ölçüde toplanır.",
    ],
  },
  {
    h: "6. Kişisel Verilerin Aktarılması",
    p: [
      "Kişisel verileriniz pazarlama amacıyla üçüncü kişilerle paylaşılmaz. Verileriniz; barındırma (hosting), e-posta iletimi ve anonim ziyaret istatistikleri gibi hizmetlerin sağlanması amacıyla, yalnızca gerekli olduğu ölçüde yetkili hizmet sağlayıcılarımızla paylaşılabilir. Bu hizmetlerin bir kısmı yurt dışında sunuculara sahip olabileceğinden, ilgili aktarımlar KVKK m.9 kapsamında ve gerekli hallerde açık rızanıza dayanılarak gerçekleştirilir.",
    ],
  },
  {
    h: "7. Saklama Süresi",
    p: [
      "Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve ilgili mevzuatta öngörülen zamanaşımı/saklama süreleri kadar muhafaza edilir; bu sürelerin sonunda silinir, yok edilir veya anonim hale getirilir.",
    ],
  },
  {
    h: "8. İlgili Kişinin Hakları (KVKK m.11)",
    p: ["KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:"],
    list: [
      "Kişisel verinizin işlenip işlenmediğini öğrenme ve buna ilişkin bilgi talep etme.",
      "İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme.",
      "Yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme.",
      "Eksik veya yanlış işlenmişse düzeltilmesini isteme.",
      "Şartları oluştuğunda silinmesini veya yok edilmesini isteme.",
      "Düzeltme/silme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme.",
      "Otomatik sistemlerle analiz sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme.",
      "Kanuna aykırı işleme nedeniyle zarara uğramanız halinde zararın giderilmesini talep etme.",
    ],
  },
  {
    h: "9. Başvuru Yöntemi",
    p: [
      `Haklarınıza ilişkin taleplerinizi, \u201cVeri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ\u201d uyarınca yazılı olarak ${LEGAL.address} adresine, ${LEGAL.email} e-posta adresine veya ${LEGAL.kep} KEP adresine iletebilirsiniz. Başvurunuz en geç 30 gün içinde ücretsiz olarak sonuçlandırılır.`,
    ],
  },
];

const Kvkk = () => (
  <main className="bg-canvas" data-testid="kvkk-page">
    <Seo
      title="KVKK Aydınlatma Metni — Koşan Düğme"
      description="6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında Koşan Düğme kişisel verilerin işlenmesine ilişkin aydınlatma metni."
      path="/kvkk-aydinlatma-metni"
    />
    <Breadcrumbs items={[{ label: "KVKK Aydınlatma Metni", to: "/kvkk-aydinlatma-metni" }]} />
    <PageHeader
      eyebrow="Yasal · KVKK"
      title="Aydınlatma Metni"
      text="Kişisel verilerinizin 6698 sayılı Kanun kapsamında nasıl işlendiğine ilişkin bilgilendirme."
    />
    <Container className="py-16 lg:py-20 max-w-3xl">
      <div className="space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.h} data-testid="kvkk-section">
            <h2 className="font-display font-light text-2xl text-ink">{s.h}</h2>
            {s.p && s.p.map((t, i) => <p key={i} className="text-ink2 leading-relaxed mt-4 text-[15px]">{t}</p>)}
            {s.list && (
              <ul className="mt-4 space-y-2.5">
                {s.list.map((t, i) => (
                  <li key={i} className="flex gap-3 text-ink2 leading-relaxed text-[15px]">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand shrink-0 mt-2.5" />
                    {t}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
        <p className="text-[12px] text-mute pt-4 border-t border-line">
          Son güncelleme: {LEGAL.updated}. Bu metin bilgilendirme amaçlıdır ve hukuki danışmanlık yerine geçmez.
        </p>
      </div>
    </Container>
  </main>
);

export default Kvkk;
